import React from "react";
import {connect} from "react-redux";
import TextBlock from "./textblock";
import languages from "../collections/languages";
import {Input} from "./inputComponent";
import {Button} from "./Button";

class verificationComponent extends React.Component {


    render() {
        return (
            <div>
                <div className={"text-box"}>
                    <TextBlock
                        text={languages[this.props.lang].emailInstructions}/>
                </div>
                <div className={"input-group flex-between input-text"}>
                    <div className={"input-group"}>
                        <Input
                            type={"text"}
                            placeholder={"E-mail"}
                            change={this.props.emailChange}
                        />
                        <Button
                            class={"button-regular"}
                            text={languages[this.props.lang].sendMail}
                            onClick={this.props.sendMail}/>
                    </div>
                    <div className={"input-group"}>
                        <Input
                            type={"text"}
                            placeholder={languages[this.props.lang].code}
                            change={this.props.codeChange}
                            blur={this.props.pastedCode}
                        />
                        <Button
                            class={"button-regular"}
                            text={"OK"}
                            onClick={this.props.submitCode}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

export const Verification = connect ( mapStateToProps ) ( verificationComponent );